import { useCallback, useEffect, useState } from "react";
import { isFilterSearchLoading } from "@/lib/query/paginatedSearch";

/**
 * Search button loading: React Query alone misses the gap between click and URL/query
 * update, and skips loading on cache hits. Keep pending until applied params settle.
 */
export function useFilterSearchButton(
  appliedSearchKey: string,
  isLoading: boolean,
  isFetching: boolean,
  isPlaceholderData: boolean,
) {
  const [pendingKey, setPendingKey] = useState<string | null>(null);
  const queryLoading = isFilterSearchLoading(
    isLoading,
    isFetching,
    isPlaceholderData,
  );

  const markSearchStarted = useCallback((nextSearchKey: string) => {
    setPendingKey(nextSearchKey);
  }, []);

  useEffect(() => {
    if (pendingKey === null) return;
    if (appliedSearchKey === pendingKey && !queryLoading) {
      setPendingKey(null);
    }
  }, [pendingKey, appliedSearchKey, queryLoading]);

  const searchLoading = queryLoading || pendingKey !== null;

  return { searchLoading, markSearchStarted };
}
